<script lang="ts" setup>
import PartnerBox from '~/components/partner/PartnerBox.vue'
import PartnerSlide from '~/components/partner/PartnerSlide.vue'
import PartnerSubtitle from '~/components/partner/PartnerSubtitle.vue'
import AuthScope from '~/enums/auth-scope'
import helpers from '~/helpers'
import { useSpecialistsStore } from '~/store/specialists'

const specialistsStore = useSpecialistsStore()
const { getSpecialists } = storeToRefs(specialistsStore)

onMounted(async (): Promise<void> => {
  await specialistsStore.fetchSpecialists(AuthScope.Client)
})
</script>

<template>
  <PartnerBox>
    <PartnerSubtitle subtitle="Нам&nbsp;доверяют более 4500&nbsp;интегративных специалистов" />

    <div class="relative -mr-2 mt-8 max-w-full [&_*]:!cursor-grab [&_*]:select-none">
      <Carousel
        class="!w-full !max-w-full !p-0"
        drag-free
        :show-buttons="false"
      >
        <div class="flex items-stretch">
          <PartnerSlide
            v-for="(x, i) in getSpecialists"
            :key="i"
            class="mr-3 max-h-[340px] min-h-[340px] min-w-[311px] max-w-[311px]"
            :specialist-data="x"
            @click.prevent="navigateTo(helpers.getSpecialistPath(x))"
          />
        </div>
      </Carousel>
    </div>
  </PartnerBox>
</template>
